import React from "react";

import { PricingFeatureTable } from "@/components/wpl/pricing/src/features-table";
import { QuestionsCta } from "@/components/wpl/pricing/src/index.ts";
import { usePricingContentContext } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { QuotationsAdornment } from "@/components/wpl/pricing/src/pricing-faq";
import {
    PricingPageLayout,
    PageHeading
} from "@/components/wpl/pricing/src/pricing-page-layout";
import { CallToAction } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { ParentScrollTracking } from "@/utils/scroll-tracking";

import { PricingFaq } from "../../../../../components/wpl/pricing/src/pricing-faq/pricing-faq";
import { SoftwareCompassPricingPageProps } from "../../../../../pages/software/compass/pricing/software-compass-pricing-page";
import { CompassNav } from "../../src/sections/compass-navbar";

import { SoftwareCompassPriceFinder } from "./sections/software-compass-price-finder";

export const SoftwareCompassPricingPageTemplate: React.FC<
    SoftwareCompassPricingPageProps
    // eslint-disable-next-line complexity
> = ({ pricing, countryCode }) => {
    const content = usePricingContentContext();
    const questionsCtaContent = content
        ?.callToActionContainer?.[0] as CallToAction;
    return (
        <PricingPageLayout
            nav={<CompassNav />}
            showFallback={content?.hasError}
        >
            <ParentScrollTracking pageId="compass-pricing-page">
                <PageHeading>{content?.headline}</PageHeading>
                <SoftwareCompassPriceFinder
                    pricing={pricing}
                    countryCode={countryCode}
                />
                <PricingFeatureTable
                    title={content?.compareFeaturesTitle ?? undefined}
                    comparePlans={content?.comparePlans ?? undefined}
                    compareFeatures={content?.compareFeatures ?? undefined}
                />
                <QuotationsAdornment>
                    <ParentScrollTracking>
                        <PricingFaq
                            header={content?.getMoreDetailsTitle ?? undefined}
                            planDetails={
                                content?.additionalDetails ?? undefined
                            }
                        />
                    </ParentScrollTracking>
                </QuotationsAdornment>
                <QuestionsCta
                    product={"Compass"}
                    ctaHref={questionsCtaContent?.url ?? undefined}
                    questionsHeader={questionsCtaContent?.title ?? undefined}
                    priceAndLicensingLinkText={
                        questionsCtaContent?.text ?? undefined
                    }
                    questionsBody={
                        questionsCtaContent?.valueProposition ?? undefined
                    }
                    imageHref={questionsCtaContent?.asset?.url}
                />
            </ParentScrollTracking>
        </PricingPageLayout>
    );
};
